export const AppLogo = () => {
  return (
    <svg
      width="76"
      height="76"
      viewBox="0 0 76 76"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.418 24.7075H45.9841C45.9841 24.7075 48.002 9.56571 39.6552 0C39.6578 0 31.9469 10.8837 34.418 24.7075Z"
        fill="#CF2727"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.5547 30.3007L35.7845 23.3265C35.7845 23.3265 28.2644 10.0293 15.8379 7.43018C15.8379 7.43018 16.248 20.7619 26.5547 30.3007Z"
        fill="#CF2727"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M52.1923 30.3007L42.9629 23.3265C42.9629 23.3265 50.4821 10.0293 62.9082 7.43018C62.9082 7.43018 62.4981 20.7619 52.1923 30.3007Z"
        fill="#CF2727"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.869 27.3742L36.3984 22.455C36.3984 22.455 41.0095 7.89192 52.6307 2.78235C52.6307 2.78235 54.9831 15.9114 46.869 27.3742Z"
        fill="#CF2727"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.188 27.3742L42.6585 22.4562C42.6585 22.4562 38.0479 7.89192 26.4263 2.78235C26.4263 2.78235 24.0738 15.9114 32.188 27.3742Z"
        fill="#CF2727"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.4161 51.0527H45.9822C45.9822 51.0527 48.0001 66.1945 39.6533 75.7598C39.6558 75.7598 31.945 64.8761 34.4161 51.0527Z"
        fill="#CF2727"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.5538 45.4594L35.7836 52.434C35.7836 52.434 28.2644 65.7307 15.8379 68.3303C15.837 68.3303 16.2472 54.9982 26.5538 45.4594Z"
        fill="#CF2727"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M52.1903 45.4592L42.9609 52.4339C42.9609 52.4339 50.4802 65.7306 62.9063 68.3302C62.9063 68.3302 62.4961 54.9981 52.1903 45.4592Z"
        fill="#CF2727"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.869 48.387L36.3984 53.3049C36.3984 53.3049 41.0078 67.8684 52.6311 72.9801C52.6307 72.9779 54.9831 59.8485 46.869 48.387Z"
        fill="#CF2727"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.188 48.387L42.6585 53.3049C42.6585 53.3049 38.0491 67.8684 26.4263 72.9801C26.4263 72.9779 24.0738 59.8485 32.188 48.387Z"
        fill="#CF2727"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.7075 33.4704V45.0365C24.7075 45.0365 9.56571 47.0544 0 38.7076C0 38.7097 10.8837 30.9993 24.7075 33.4704Z"
        fill="#CF2727"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.3007 25.6068L23.326 34.8362C23.326 34.8362 10.0289 27.3174 7.42969 14.8909C7.42969 14.8909 20.7614 15.301 30.3007 25.6068Z"
        fill="#CF2727"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.3007 51.2445L23.326 42.0134C23.326 42.0134 10.0289 49.5327 7.42969 61.9587C7.42969 61.9605 20.7614 61.5503 30.3007 51.2445Z"
        fill="#CF2727"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.3742 45.9233L22.4562 35.4524C22.4562 35.4524 7.89277 40.0618 2.7832 51.685C2.7832 51.685 15.9126 54.0371 27.3742 45.9233Z"
        fill="#CF2727"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.3742 31.2413L22.4562 41.7119C22.4562 41.7119 7.89277 37.1012 2.7832 25.4796C2.7832 25.4796 15.9126 23.1276 27.3742 31.2413Z"
        fill="#CF2727"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.8965 33.4704V45.0365C50.8965 45.0365 66.0382 47.0544 75.604 38.7076C75.604 38.7097 64.7203 30.9993 50.8965 33.4704Z"
        fill="#CF2727"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.3027 25.6067L52.277 34.8361C52.277 34.8361 65.5741 27.3173 68.1737 14.8907C68.1737 14.8907 54.8416 15.3009 45.3027 25.6067Z"
        fill="#CF2727"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.3027 51.2445L52.277 42.0134C52.277 42.0134 65.5741 49.5327 68.1737 61.9587C68.1737 61.9605 54.8416 61.5503 45.3027 51.2445Z"
        fill="#CF2727"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48.2305 45.9233L53.1484 35.4524C53.1484 35.4524 67.7114 40.0618 72.821 51.685C72.821 51.685 59.692 54.0371 48.2305 45.9233Z"
        fill="#CF2727"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48.2305 31.2413L53.1484 41.7119C53.1484 41.7119 67.7114 37.1025 72.821 25.4796C72.821 25.4796 59.692 23.1276 48.2305 31.2413Z"
        fill="#CF2727"
      />
      <path
        d="M37.8 53.6439C46.5067 53.6439 53.5649 46.5857 53.5649 37.879C53.5649 29.1723 46.5067 22.1141 37.8 22.1141C29.0933 22.1141 22.0352 29.1723 22.0352 37.879C22.0352 46.5857 29.0933 53.6439 37.8 53.6439Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.641 36.3427H50.3079C50.3079 36.3427 51.4705 27.6165 46.6601 22.1036C46.6601 22.1036 42.2164 28.3762 43.641 36.3427Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.1093 39.5664L44.4284 35.5469C44.4284 35.5469 40.0952 27.8838 32.9336 26.3857C32.9336 26.3857 33.1688 34.0689 39.1093 39.5664Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M53.8851 39.5664L48.5664 35.5469C48.5664 35.5469 52.8996 27.8838 60.0608 26.3857C60.0608 26.3857 59.8248 34.0689 53.8851 39.5664Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.8176 37.8791L44.7832 35.0448C44.7832 35.0448 47.4404 26.6519 54.1381 23.707C54.1381 23.707 55.4936 31.2736 50.8176 37.8791Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.3565 37.8791L48.391 35.0448C48.391 35.0448 45.7337 26.6519 39.0361 23.707C39.0361 23.707 37.6806 31.2736 42.3565 37.8791Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.641 51.5254H50.3079C50.3079 51.5254 51.4705 60.252 46.6601 65.7645C46.6601 65.7645 42.2164 59.4923 43.641 51.5254Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.1093 48.3024L44.4284 52.3215C44.4284 52.3215 40.0952 59.9846 32.9336 61.4826C32.9336 61.4826 33.1688 53.7995 39.1093 48.3024Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M53.8851 48.3021L48.5664 52.3212C48.5664 52.3212 52.8996 59.9843 60.0608 61.4824C60.0608 61.4824 59.8248 53.7992 53.8851 48.3021Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.8176 49.9893L44.7832 52.8236C44.7832 52.8236 47.4404 61.2165 54.1381 64.1609C54.1381 64.1609 55.4936 56.5947 50.8176 49.9893Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.3565 49.9893L48.391 52.8236C48.391 52.8236 45.7337 61.2165 39.0361 64.1609C39.0361 64.1609 37.6806 56.5947 42.3565 49.9893Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.0457 41.3931V48.0596C38.0457 48.0596 29.3195 49.2226 23.8066 44.4122C23.8066 44.4122 30.0792 39.9684 38.0457 41.3931Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.2688 36.8609L37.2493 42.18C37.2493 42.18 29.5862 37.8468 28.0898 30.6852C28.0898 30.6852 35.7721 30.9216 41.2688 36.8609Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.2685 51.636L37.249 46.3173C37.249 46.3173 29.5859 50.6505 28.0879 57.8116C28.0896 57.8116 35.7719 57.5756 41.2685 51.636Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.5822 48.5696L36.7479 42.5352C36.7479 42.5352 28.355 45.1924 25.4102 51.89C25.4102 51.89 32.9768 53.2455 39.5822 48.5696Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.5822 40.1079L36.7479 46.1423C36.7479 46.1423 28.355 43.4851 25.4102 36.7874C25.4102 36.7874 32.9768 35.4319 39.5822 40.1079Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M53.1406 41.3931V48.0596C53.1406 48.0596 61.8668 49.2226 67.3797 44.4122C67.3797 44.4122 61.1071 39.9684 53.1406 41.3931Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M49.916 36.861L53.9356 42.1801C53.9356 42.1801 61.5986 37.8469 63.0967 30.6853C63.0967 30.6853 55.4135 30.9217 49.916 36.861Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M49.916 51.636L53.9356 46.3173C53.9356 46.3173 61.5986 50.6505 63.0967 57.8116C63.0967 57.8116 55.4135 57.5756 49.916 51.636Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M51.6035 48.5696L54.4378 42.5352C54.4378 42.5352 62.8307 45.1924 65.7752 51.89C65.7769 51.89 58.2086 53.2455 51.6035 48.5696Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M51.6035 40.1079L54.4378 46.1423C54.4378 46.1423 62.8307 43.4851 65.7752 36.7874C65.7769 36.7874 58.2086 35.4319 51.6035 40.1079Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.0528 34.8966C47.7662 34.897 49.4411 35.4055 50.8656 36.3578C52.2901 37.31 53.4002 38.6633 54.0556 40.2465C54.7111 41.8296 54.8823 43.5716 54.5478 45.2521C54.2132 46.9325 53.3879 48.4761 52.1762 49.6876C50.9644 50.899 49.4207 51.724 47.7401 52.0581C46.0595 52.3922 44.3176 52.2205 42.7346 51.5647C41.1516 50.9089 39.7986 49.7984 38.8467 48.3737C37.8948 46.949 37.3867 45.274 37.3867 43.5605C37.3884 41.2628 38.3021 39.0598 39.9269 37.4353C41.5518 35.8108 43.7551 34.8977 46.0528 34.8966Z"
        fill="#CF2727"
        stroke="#F37228"
        strokeWidth="0.426793"
        strokeMiterlimit="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Rewind10SecSVG = ({
  size = 31,
  color = "#1F1F1F",
}: {
  size?: number;
  color?: string;
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 31 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.33789 16.8496C7.03777 16.8496 7.59407 17.4213 7.7097 18.1115C8.31202 21.7071 11.4439 24.4531 15.2087 24.4531C19.4033 24.4531 22.8122 21.0442 22.8122 16.8496C22.8122 13.1598 20.1744 10.078 16.6844 9.38964C15.8799 9.23097 15.2087 9.91081 15.2087 10.7308C15.2087 12.0535 13.6094 12.7159 12.6742 11.7806L9.94769 9.05414C9.35382 8.46027 9.35382 7.49741 9.94769 6.90354L12.6742 4.17708C13.6094 3.24179 15.2087 3.9042 15.2087 5.22691C15.2087 6.04688 15.8772 6.70017 16.6886 6.81871C21.5877 7.53452 25.3467 11.7511 25.3467 16.8496C25.3467 22.4509 20.8099 26.9876 15.2087 26.9876C10.0357 26.9876 5.77071 23.1182 5.14867 18.1144C5.06233 17.4198 5.638 16.8496 6.33789 16.8496Z"
      fill={color}
    />
    <path
      d="M13.5983 20.5808V15.1697H13.4842L11.2412 15.968V16.8425L12.5211 16.4496V20.5808H13.5983ZM15.3598 17.4127V18.3505C15.3598 20.7583 17.0199 20.6569 17.1846 20.6569C17.362 20.6569 19.0095 20.7709 19.0095 18.3505V17.4127C19.0095 15.0049 17.3494 15.1063 17.1846 15.1063C17.0072 15.1063 15.3598 14.9923 15.3598 17.4127ZM17.945 17.2606V18.4899C17.945 19.4657 17.6789 19.7951 17.1973 19.7951C16.7157 19.7951 16.4369 19.4657 16.4369 18.4899V17.2606C16.4369 16.3102 16.7157 15.9807 17.1846 15.9807C17.6662 15.968 17.945 16.3102 17.945 17.2606Z"
      fill={color}
    />
  </svg>
);

export const Forward10SecSVG = ({
  size = 31,
  color = "#1F1F1F",
}: {
  size?: number;
  color?: string;
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 31 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.3184 16.8496C23.6185 16.8496 23.0622 17.4213 22.9465 18.1115C22.3442 21.7071 19.2124 24.4531 15.4476 24.4531C11.253 24.4531 7.84408 21.0442 7.84408 16.8496C7.84408 13.1598 10.4819 10.078 13.9719 9.38964C14.7764 9.23097 15.4476 9.91081 15.4476 10.7308C15.4476 12.0535 17.0468 12.7159 17.9821 11.7806L20.7086 9.05414C21.3024 8.46027 21.3024 7.49741 20.7086 6.90354L17.9821 4.17708C17.0468 3.24179 15.4476 3.9042 15.4476 5.22691C15.4476 6.04688 14.779 6.70017 13.9677 6.81871C9.06852 7.53452 5.30957 11.7511 5.30957 16.8496C5.30957 22.4509 9.84633 26.9876 15.4476 26.9876C20.6205 26.9876 24.8855 23.1182 25.5076 18.1144C25.5939 17.4198 25.0182 16.8496 24.3184 16.8496Z"
      fill={color}
    />
    <path
      d="M14.0055 20.5808V15.1697H13.8915L11.6484 15.968V16.8425L12.9284 16.4496V20.5808H14.0055ZM15.767 17.4127V18.3505C15.767 20.7583 17.4271 20.6569 17.5919 20.6569C17.7693 20.6569 19.4167 20.7709 19.4167 18.3505V17.4127C19.4167 15.0049 17.7566 15.1063 17.5919 15.1063C17.4144 15.1063 15.767 14.9923 15.767 17.4127ZM18.3522 17.2606V18.4899C18.3522 19.4657 18.0861 19.7951 17.6045 19.7951C17.123 19.7951 16.8442 19.4657 16.8442 18.4899V17.2606C16.8442 16.3102 17.123 15.9807 17.5919 15.9807C18.0734 15.968 18.3522 16.3102 18.3522 17.2606Z"
      fill={color}
    />
  </svg>
);

export const AssignmentUserSVG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="48" height="48" rx="24" fill="#FCFCFC" />
    <mask
      id="mask0_716_23555"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="4"
      y="4"
      width="40"
      height="40"
    >
      <rect x="4" y="4" width="40" height="40" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_716_23555)">
      <path
        d="M13.7497 32.5007C15.1663 31.4173 16.7497 30.5632 18.4997 29.9382C20.2497 29.3132 22.083 29.0007 23.9997 29.0007C25.9163 29.0007 27.7497 29.3132 29.4997 29.9382C31.2497 30.5632 32.833 31.4173 34.2497 32.5007C35.2219 31.3618 35.9788 30.0701 36.5205 28.6257C37.0622 27.1812 37.333 25.6395 37.333 24.0007C37.333 20.3062 36.0344 17.1604 33.4372 14.5632C30.84 11.9659 27.6941 10.6673 23.9997 10.6673C20.3052 10.6673 17.1594 11.9659 14.5622 14.5632C11.965 17.1604 10.6663 20.3062 10.6663 24.0007C10.6663 25.6395 10.9372 27.1812 11.4788 28.6257C12.0205 30.0701 12.7775 31.3618 13.7497 32.5007ZM23.9997 25.6673C22.3608 25.6673 20.9788 25.1048 19.8538 23.9798C18.7288 22.8548 18.1663 21.4729 18.1663 19.834C18.1663 18.1951 18.7288 16.8132 19.8538 15.6882C20.9788 14.5632 22.3608 14.0007 23.9997 14.0007C25.6386 14.0007 27.0205 14.5632 28.1455 15.6882C29.2705 16.8132 29.833 18.1951 29.833 19.834C29.833 21.4729 29.2705 22.8548 28.1455 23.9798C27.0205 25.1048 25.6386 25.6673 23.9997 25.6673ZM23.9997 40.6673C21.6941 40.6673 19.5275 40.2298 17.4997 39.3548C15.4719 38.4798 13.708 37.2923 12.208 35.7923C10.708 34.2923 9.52051 32.5284 8.64551 30.5007C7.77051 28.4729 7.33301 26.3062 7.33301 24.0007C7.33301 21.6951 7.77051 19.5284 8.64551 17.5007C9.52051 15.4729 10.708 13.709 12.208 12.209C13.708 10.709 15.4719 9.52148 17.4997 8.64648C19.5275 7.77148 21.6941 7.33398 23.9997 7.33398C26.3052 7.33398 28.4719 7.77148 30.4997 8.64648C32.5275 9.52148 34.2913 10.709 35.7913 12.209C37.2913 13.709 38.4788 15.4729 39.3538 17.5007C40.2288 19.5284 40.6663 21.6951 40.6663 24.0007C40.6663 26.3062 40.2288 28.4729 39.3538 30.5007C38.4788 32.5284 37.2913 34.2923 35.7913 35.7923C34.2913 37.2923 32.5275 38.4798 30.4997 39.3548C28.4719 40.2298 26.3052 40.6673 23.9997 40.6673Z"
        fill="#5C88C5"
      />
    </g>
  </svg>
);

export const RecordButtonSVG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="0.619942"
      y="0.863106"
      width="58.2746"
      height="58.2746"
      rx="29.1373"
      fill="white"
    />
    <rect
      x="0.619942"
      y="0.863106"
      width="58.2746"
      height="58.2746"
      rx="29.1373"
      stroke="#C53921"
      stroke-width="1.23988"
    />
    <rect
      x="7.6962"
      y="8.19629"
      width="44.6358"
      height="44.6358"
      rx="22.3179"
      fill="#C53921"
    />
  </svg>
);

export const PauseButtonSVG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="61"
    height="62"
    viewBox="0 0 61 62"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="0.631104"
      y="1.33813"
      width="59.3237"
      height="59.3237"
      rx="29.6619"
      fill="white"
    />
    <rect
      x="0.631104"
      y="1.33813"
      width="59.3237"
      height="59.3237"
      rx="29.6619"
      stroke="#C53921"
      stroke-width="1.26221"
    />
    <rect
      width="31.5552"
      height="31.5552"
      transform="translate(14.4711 15.1133)"
      fill="#C53921"
    />
  </svg>
);

export const DashboardCardWaveSVG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="360"
    height="65"
    viewBox="0 0 360 65"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M85.47 86.5506C60.7796 88.7251 34.2826 87.8553 13.8075 76.1131C-18.4659 58.6327 -54.5826 48.4404 -92.3975 52.6607V106.097H220.883C197.432 99.5689 176.975 87.8531 151.713 86.1157C129.431 84.3761 107.752 84.3761 85.47 86.5506Z"
      fill="#FFE6E4"
    />
    <path
      d="M359.397 113.829C321.312 123.394 302.117 111.905 269.366 89.766C246.476 74.307 208.846 67.5756 208.846 54.3264C118.284 55.8435 81.5954 72.64 44.8494 44.9204C7.88422 17.0196 -44.532 -9.81526 -92.3975 7.65128V57.5012C-54.5708 52.3289 -18.4429 64.8219 13.8405 86.2475C34.3218 100.64 60.8271 101.707 85.5252 99.0412C107.814 96.3759 129.5 96.3759 151.788 98.5081C177.059 100.638 197.521 114.998 220.98 123H359.397V113.829Z"
      fill="#5C88C5"
    />
    <path
      d="M333.579 84.0916C288.413 88.0057 251.679 71.0446 213.138 56.258C202.298 51.909 190.254 49.7346 177.005 50.6043C147.497 52.7788 119.194 55.3882 89.6855 51.909C52.9509 47.995 28.2605 27.5547 -2.45199 13.203C-14.4961 7.98426 -26.5402 3.63527 -40.9932 1.46078C-56.0483 -0.27882 -70.5013 -0.27882 -83.7498 3.20037C-86.5103 3.94796 -89.4677 4.40591 -92.3975 4.74557V9.96697C-44.5468 -4.28292 5.15749 26.9719 42.1113 49.7346C78.8458 72.3493 129.431 59.7372 172.79 57.9976C202.298 57.1278 224.58 67.5654 247.463 80.1775C280.204 98.2393 321.184 104.394 359.257 96.591V82.0963C350.724 82.6951 342.17 83.3531 333.579 84.0916Z"
      fill="#EFEBE9"
    />
  </svg>
);

export const UnitAddCircleIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
    {...props}
  >
    <path
      d="M14.666 17.3327V21.3327C14.666 21.7105 14.7938 22.0271 15.0493 22.2827C15.3049 22.5382 15.6216 22.666 15.9993 22.666C16.3771 22.666 16.6938 22.5382 16.9493 22.2827C17.2049 22.0271 17.3327 21.7105 17.3327 21.3327V17.3327H21.3327C21.7105 17.3327 22.0271 17.2049 22.2827 16.9493C22.5382 16.6938 22.666 16.3771 22.666 15.9993C22.666 15.6216 22.5382 15.3049 22.2827 15.0493C22.0271 14.7938 21.7105 14.666 21.3327 14.666H17.3327V10.666C17.3327 10.2882 17.2049 9.97157 16.9493 9.71601C16.6938 9.46046 16.3771 9.33268 15.9993 9.33268C15.6216 9.33268 15.3049 9.46046 15.0493 9.71601C14.7938 9.97157 14.666 10.2882 14.666 10.666V14.666H10.666C10.2882 14.666 9.97157 14.7938 9.71601 15.0493C9.46046 15.3049 9.33268 15.6216 9.33268 15.9993C9.33268 16.3771 9.46046 16.6938 9.71601 16.9493C9.97157 17.2049 10.2882 17.3327 10.666 17.3327H14.666ZM15.9993 29.3327C14.1549 29.3327 12.4216 28.9827 10.7993 28.2827C9.17713 27.5827 7.76602 26.6327 6.56602 25.4327C5.36602 24.2327 4.41602 22.8216 3.71602 21.1993C3.01602 19.5771 2.66602 17.8438 2.66602 15.9993C2.66602 14.1549 3.01602 12.4216 3.71602 10.7993C4.41602 9.17713 5.36602 7.76602 6.56602 6.56602C7.76602 5.36602 9.17713 4.41602 10.7993 3.71602C12.4216 3.01602 14.1549 2.66602 15.9993 2.66602C17.8438 2.66602 19.5771 3.01602 21.1993 3.71602C22.8216 4.41602 24.2327 5.36602 25.4327 6.56602C26.6327 7.76602 27.5827 9.17713 28.2827 10.7993C28.9827 12.4216 29.3327 14.1549 29.3327 15.9993C29.3327 17.8438 28.9827 19.5771 28.2827 21.1993C27.5827 22.8216 26.6327 24.2327 25.4327 25.4327C24.2327 26.6327 22.8216 27.5827 21.1993 28.2827C19.5771 28.9827 17.8438 29.3327 15.9993 29.3327ZM15.9993 26.666C18.9771 26.666 21.4993 25.6327 23.566 23.566C25.6327 21.4993 26.666 18.9771 26.666 15.9993C26.666 13.0216 25.6327 10.4993 23.566 8.43268C21.4993 6.36602 18.9771 5.33268 15.9993 5.33268C13.0216 5.33268 10.4993 6.36602 8.43268 8.43268C6.36602 10.4993 5.33268 13.0216 5.33268 15.9993C5.33268 18.9771 6.36602 21.4993 8.43268 23.566C10.4993 25.6327 13.0216 26.666 15.9993 26.666Z"
      fill="#5C88C5"
    />
  </svg>
);

export const MyClassNavIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={30}
    height={30}
    viewBox="0 0 30 30"
    fill="none"
    {...props}
  >
    <path
      d="M2.5 7.5H7.5"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 12.5H7.5"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 17.5H7.5"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 22.5H7.5"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.5 2.5H7.5C6.11929 2.5 5 3.61929 5 5V25C5 26.3807 6.11929 27.5 7.5 27.5H22.5C23.8807 27.5 25 26.3807 25 25V5C25 3.61929 23.8807 2.5 22.5 2.5Z"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.75 2.5V27.5"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.75 8.75H25"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.75 15H25"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.75 21.25H25"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SchoolSelectorIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={23}
    height={23}
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.079 6.70268C12.4547 6.70268 13.6393 7.67399 13.908 9.02292C14.1776 10.3728 13.4556 11.7236 12.1842 12.2507C10.9138 12.7779 9.44762 12.3329 8.68322 11.1898C7.91872 10.0459 8.06829 8.52152 9.04053 7.54841C9.58067 7.00643 10.3145 6.70176 11.079 6.70268ZM11.079 2.56348L6.9528 6.6131V8.97305L6.95372 8.97397V21.5076H7.6028V15.4536C7.6028 15.3188 7.6859 15.1979 7.81239 15.1489L10.9515 13.8009C11.0337 13.7659 11.126 13.7659 11.2082 13.8009L14.3613 15.1554C14.4804 15.2062 14.557 15.3235 14.557 15.4536V21.5076H15.2061V6.61293L11.079 2.56348ZM6.3028 7.2501L5.86978 7.67574H5.8707C5.74329 7.80131 5.53833 7.79946 5.41275 7.67205L4.51993 6.76259V6.76351C4.39436 6.6361 4.39621 6.43114 4.52363 6.30556L5.69528 5.15513H1.8617L0.766673 8.64977H6.30373L6.3028 7.2501ZM6.35543 4.50615L10.8518 0.0937151L10.8527 0.0927916C10.9783 -0.0309305 11.1805 -0.0309305 11.306 0.0927916L15.8033 4.50523H20.536V4.50615C20.6782 4.50615 20.8029 4.59848 20.8453 4.7342L22.137 8.85851L22.138 8.86128V8.86221L22.1389 8.86313V8.8659L22.1398 8.86682L22.1407 8.87144L22.1416 8.87421V8.8779L22.1426 8.87883V8.87975L22.1435 8.88252V8.88344L22.1444 8.88621V8.8899L22.1453 8.89083V8.89452L22.1463 8.89544V8.89914H22.1472V8.90191L22.1481 8.90652V8.91022L22.149 8.91391V8.91483L22.15 8.9176V8.92407L22.1509 8.92499V8.93238L22.1518 8.93976V8.94069L22.1527 8.94807V8.95731L22.1592 8.97485V10.1991C22.1592 10.3783 22.0133 10.5232 21.8342 10.5232H20.8601V21.8327C20.8601 22.0119 20.7152 22.1577 20.536 22.1577H1.62316C1.44404 22.1577 1.29908 22.0119 1.29908 21.8327V10.5232H0.325C0.145881 10.5232 0 10.3783 0 10.1991V8.97485C0 8.93515 0.00738636 8.89544 0.0221591 8.85851L1.30739 4.75264C1.34432 4.60768 1.47358 4.50611 1.62314 4.50611L6.35543 4.50615ZM16.4638 5.15523L17.6363 6.30566C17.7637 6.43123 17.7656 6.63619 17.64 6.76361L16.7472 7.67307V7.67215C16.6216 7.79956 16.4167 7.80141 16.2893 7.67584L15.8553 7.2502V8.64992H21.3933L20.2983 5.15528L16.4638 5.15523ZM5.64728 6.98797L10.8527 1.87944C10.9783 1.75572 11.1805 1.75572 11.3061 1.87944L16.5115 6.98797L16.9519 6.54018L15.4654 5.08137H15.4645C15.4497 5.06844 15.4359 5.05551 15.4229 5.04074L11.0788 0.777922L6.73089 5.04452C6.72074 5.05652 6.70966 5.06853 6.69673 5.07868L5.20745 6.54026L5.64728 6.98797ZM13.908 17.002H13.2589V21.5076H13.908V17.002ZM12.6098 17.002H9.54912V21.5076H12.6098V17.002ZM8.90007 17.002H8.25191V21.5076H8.90099L8.90007 17.002ZM13.9081 15.6669L11.0791 14.4509L8.25102 15.6669V16.3529H13.9081V15.6669ZM3.80076 20.2833V17.0019H3.19877V20.2833H3.80076ZM4.45076 17.0019V20.2833H5.05276L5.05368 17.0019H4.45076ZM2.87469 16.3528H5.37873C5.55784 16.3528 5.7028 16.4987 5.7028 16.6778V20.6083C5.7028 20.6942 5.66864 20.7763 5.60771 20.8373C5.54677 20.8982 5.46459 20.9324 5.37873 20.9324H2.87469C2.78883 20.9324 2.70573 20.8982 2.64479 20.8382C2.58385 20.7773 2.54969 20.6942 2.54969 20.6083V16.6778C2.54969 16.5919 2.58385 16.5089 2.64479 16.4479C2.70573 16.387 2.78882 16.3528 2.87469 16.3528ZM3.80076 15.0547V12.1722H3.19877V15.0547H3.80076ZM4.45076 12.1722V15.0547H5.05276V12.1722H4.45076ZM2.87469 11.5231H5.37873C5.46459 11.5231 5.54677 11.5573 5.6077 11.6173C5.66864 11.6782 5.7028 11.7613 5.7028 11.8472V15.3806V15.3797C5.7028 15.4655 5.66864 15.5486 5.6077 15.6087C5.54677 15.6696 5.46459 15.7038 5.37873 15.7038H2.87469C2.78882 15.7038 2.70573 15.6705 2.64479 15.6096C2.58385 15.5486 2.54969 15.4655 2.54969 15.3797V11.8472C2.54969 11.7604 2.58385 11.6783 2.64479 11.6173C2.70572 11.5564 2.78882 11.5222 2.87469 11.5231ZM17.7084 20.2832L17.7093 17.0018H17.1073V20.2832H17.7084ZM18.3575 17.0018V20.2832H18.9613V17.0018H18.3575ZM16.7814 16.3527H19.2854C19.4646 16.3527 19.6104 16.4986 19.6104 16.6777V20.6082C19.6104 20.7873 19.4646 20.9323 19.2854 20.9323H16.7814C16.6955 20.9323 16.6134 20.8981 16.5524 20.8372C16.4915 20.7763 16.4573 20.6941 16.4573 20.6082V16.6777C16.4573 16.4986 16.6023 16.3527 16.7814 16.3527ZM17.7084 15.0546V12.1721H17.1064V15.0546H17.7084ZM18.3575 12.1721V15.0546H18.9613V12.1721H18.3575ZM16.7814 11.523H19.2854C19.4646 11.523 19.6104 11.668 19.6104 11.8471V15.3805V15.3796C19.6104 15.5587 19.4646 15.7037 19.2854 15.7037H16.7814C16.6955 15.7037 16.6134 15.6695 16.5524 15.6086C16.4915 15.5486 16.4573 15.4655 16.4573 15.3796V11.8471C16.4573 11.7613 16.4915 11.6782 16.5524 11.6172C16.6134 11.5572 16.6955 11.523 16.7814 11.523ZM21.5096 9.87402V9.2988H15.8553V9.87402H21.5096ZM6.30388 9.87402V9.2988H0.649585V9.87402H6.30388ZM20.2115 21.5076V10.5231H15.8553V21.5076H20.2115ZM6.30388 10.5231H1.94864V21.5076H6.30388V10.5231ZM10.2528 9.91094C10.166 9.91094 10.0829 9.8777 10.022 9.81676C9.96104 9.75582 9.92688 9.67272 9.92688 9.58594C9.92688 9.50007 9.96104 9.41697 10.022 9.35604C10.0829 9.2951 10.166 9.26186 10.2528 9.26186H10.756V8.32565C10.7551 8.23978 10.7892 8.15668 10.8502 8.09574C10.9111 8.03388 10.9942 7.99972 11.0801 7.99972C11.1669 7.99972 11.249 8.03388 11.31 8.09574C11.3709 8.15668 11.4051 8.23978 11.4042 8.32565V9.58686C11.4042 9.67272 11.37 9.75582 11.3091 9.81676C11.2481 9.8777 11.1659 9.91094 11.0792 9.91094H10.2528ZM12.6599 8.0071C11.9056 7.25461 10.7256 7.13827 9.84011 7.73103C8.95467 8.32286 8.61029 9.45851 9.01837 10.4419C9.42648 11.4261 10.4726 11.9847 11.5177 11.777C12.5619 11.5692 13.3144 10.6524 13.3144 9.58691C13.3153 8.99415 13.08 8.42534 12.6599 8.0071Z"
      fill="white"
    />
  </svg>
);

export const CourseTermAccessIcon = (
  props: React.SVGProps<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={21}
    viewBox="0 0 20 21"
    fill="none"
    {...props}
  >
    <path
      d="M8.3 18C8.4 18.3333 8.5375 18.6792 8.7125 19.0375C8.8875 19.3958 9.06667 19.7167 9.25 20H2C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H14C14.55 0 15.0208 0.195833 15.4125 0.5875C15.8042 0.979167 16 1.45 16 2V9.1C15.7 9.06667 15.3667 9.05 15 9.05C14.6333 9.05 14.3 9.06667 14 9.1V2H9V9L6.5 7.5L4 9V2H2V18H8.3ZM15 21C13.6167 21 12.4375 20.5125 11.4625 19.5375C10.4875 18.5625 10 17.3833 10 16C10 14.6167 10.4875 13.4375 11.4625 12.4625C12.4375 11.4875 13.6167 11 15 11C16.3833 11 17.5625 11.4875 18.5375 12.4625C19.5125 13.4375 20 14.6167 20 16C20 17.3833 19.5125 18.5625 18.5375 19.5375C17.5625 20.5125 16.3833 21 15 21ZM13.75 18.5L17.75 16L13.75 13.5V18.5ZM8.3 2H2H14H8H8.3Z"
      fill="#1C1B1F"
    />
  </svg>
);

export const ModalCloseSVG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_393_111619"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={24}
      height={24}
    >
      <rect width={24} height={24} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_393_111619)">
      <path
        d="M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z"
        fill="#1C1B1F"
      />
    </g>
  </svg>
);

export const ArrowLeftDoubleSVG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.33339 11.3333L4.00006 7.99999L7.33339 4.66666M12.0001 11.3333L8.66673 7.99999L12.0001 4.66666"
      stroke="#1F1F1F"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowLeftSVG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.0001 12L6.00006 8L10.0001 4"
      stroke="#1F1F1F"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowRightDoubleSVG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 11.3333L7.33333 7.99999L4 4.66666M8.66667 11.3333L12 7.99999L8.66667 4.66666"
      stroke="#1F1F1F"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowRightSVG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6 12L10 8L6 4"
      stroke="#1F1F1F"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MicSVG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={21}
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_860_10528"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={20}
      height={21}
    >
      <rect y={0.695312} width={20} height={20} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_860_10528)">
      <path
        d="M9.99996 12.3613C9.30552 12.3613 8.71524 12.1183 8.22913 11.6322C7.74302 11.1461 7.49996 10.5558 7.49996 9.86133V4.86133C7.49996 4.16688 7.74302 3.57661 8.22913 3.09049C8.71524 2.60438 9.30552 2.36133 9.99996 2.36133C10.6944 2.36133 11.2847 2.60438 11.7708 3.09049C12.2569 3.57661 12.5 4.16688 12.5 4.86133V9.86133C12.5 10.5558 12.2569 11.1461 11.7708 11.6322C11.2847 12.1183 10.6944 12.3613 9.99996 12.3613ZM9.16663 18.1947V15.6322C7.72218 15.4377 6.52774 14.7919 5.58329 13.6947C4.63885 12.5974 4.16663 11.3197 4.16663 9.86133H5.83329C5.83329 11.0141 6.23954 11.9967 7.05204 12.8092C7.86454 13.6217 8.84718 14.028 9.99996 14.028C11.1527 14.028 12.1354 13.6217 12.9479 12.8092C13.7604 11.9967 14.1666 11.0141 14.1666 9.86133H15.8333C15.8333 11.3197 15.3611 12.5974 14.4166 13.6947C13.4722 14.7919 12.2777 15.4377 10.8333 15.6322V18.1947H9.16663ZM9.99996 10.6947C10.2361 10.6947 10.434 10.6148 10.5937 10.4551C10.7534 10.2954 10.8333 10.0974 10.8333 9.86133V4.86133C10.8333 4.62522 10.7534 4.4273 10.5937 4.26758C10.434 4.10786 10.2361 4.02799 9.99996 4.02799C9.76385 4.02799 9.56593 4.10786 9.40621 4.26758C9.24649 4.4273 9.16663 4.62522 9.16663 4.86133V9.86133C9.16663 10.0974 9.24649 10.2954 9.40621 10.4551C9.56593 10.6148 9.76385 10.6947 9.99996 10.6947Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const VideoSVG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={21}
    height={20}
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_860_10532"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={21}
      height={20}
    >
      <rect x={0.557617} width={20} height={20} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_860_10532)">
      <path
        d="M3.89091 3.33398L5.55758 6.66732H8.05758L6.39091 3.33398H8.05758L9.72424 6.66732H12.2242L10.5576 3.33398H12.2242L13.8909 6.66732H16.3909L14.7242 3.33398H17.2242C17.6826 3.33398 18.0749 3.49718 18.4013 3.82357C18.7277 4.14996 18.8909 4.54232 18.8909 5.00065V15.0007C18.8909 15.459 18.7277 15.8513 18.4013 16.1777C18.0749 16.5041 17.6826 16.6673 17.2242 16.6673H3.89091C3.43258 16.6673 3.04022 16.5041 2.71383 16.1777C2.38744 15.8513 2.22424 15.459 2.22424 15.0007V5.00065C2.22424 4.54232 2.38744 4.14996 2.71383 3.82357C3.04022 3.49718 3.43258 3.33398 3.89091 3.33398ZM3.89091 8.33398V15.0007H17.2242V8.33398H3.89091Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const PDFSVG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_860_10536"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={20}
      height={20}
    >
      <rect width={20} height={20} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_860_10536)">
      <path
        d="M7.49996 10.416H8.33329V8.74935H9.16663C9.40274 8.74935 9.60065 8.66949 9.76038 8.50977C9.9201 8.35004 9.99996 8.15213 9.99996 7.91602V7.08268C9.99996 6.84657 9.9201 6.64865 9.76038 6.48893C9.60065 6.32921 9.40274 6.24935 9.16663 6.24935H7.49996V10.416ZM8.33329 7.91602V7.08268H9.16663V7.91602H8.33329ZM10.8333 10.416H12.5C12.7361 10.416 12.934 10.3362 13.0937 10.1764C13.2534 10.0167 13.3333 9.81879 13.3333 9.58268V7.08268C13.3333 6.84657 13.2534 6.64865 13.0937 6.48893C12.934 6.32921 12.7361 6.24935 12.5 6.24935H10.8333V10.416ZM11.6666 9.58268V7.08268H12.5V9.58268H11.6666ZM14.1666 10.416H15V8.74935H15.8333V7.91602H15V7.08268H15.8333V6.24935H14.1666V10.416ZM6.66663 14.9993C6.20829 14.9993 5.81593 14.8362 5.48954 14.5098C5.16315 14.1834 4.99996 13.791 4.99996 13.3327V3.33268C4.99996 2.87435 5.16315 2.48199 5.48954 2.1556C5.81593 1.82921 6.20829 1.66602 6.66663 1.66602H16.6666C17.125 1.66602 17.5173 1.82921 17.8437 2.1556C18.1701 2.48199 18.3333 2.87435 18.3333 3.33268V13.3327C18.3333 13.791 18.1701 14.1834 17.8437 14.5098C17.5173 14.8362 17.125 14.9993 16.6666 14.9993H6.66663ZM6.66663 13.3327H16.6666V3.33268H6.66663V13.3327ZM3.33329 18.3327C2.87496 18.3327 2.4826 18.1695 2.15621 17.8431C1.82982 17.5167 1.66663 17.1243 1.66663 16.666V4.99935H3.33329V16.666H15V18.3327H3.33329Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const DocumentSVG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={21}
    height={20}
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_860_10540"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={21}
      height={20}
    >
      <rect x={0.609619} width={20} height={20} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_860_10540)">
      <path
        d="M6.44295 14.1667H12.2763V12.5H6.44295V14.1667ZM6.44295 10.8333H14.7763V9.16667H6.44295V10.8333ZM6.44295 7.5H14.7763V5.83333H6.44295V7.5ZM4.77629 17.5C4.31795 17.5 3.92559 17.3368 3.5992 17.0104C3.27281 16.684 3.10962 16.2917 3.10962 15.8333V4.16667C3.10962 3.70833 3.27281 3.31597 3.5992 2.98958C3.92559 2.66319 4.31795 2.5 4.77629 2.5H16.443C16.9013 2.5 17.2936 2.66319 17.62 2.98958C17.9464 3.31597 18.1096 3.70833 18.1096 4.16667V15.8333C18.1096 16.2917 17.9464 16.684 17.62 17.0104C17.2936 17.3368 16.9013 17.5 16.443 17.5H4.77629ZM4.77629 15.8333H16.443V4.16667H4.77629V15.8333Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const AudioPlaySVG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={49}
    height={49}
    viewBox="0 0 49 49"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1002_20060)">
      <path
        d="M48.8284 24.5859C48.8284 30.9511 46.2998 37.0556 41.7989 41.5565C37.2981 46.0574 31.1936 48.5859 24.8284 48.5859C18.4632 48.5859 12.3587 46.0574 7.85781 41.5565C3.35693 37.0556 0.828369 30.9511 0.828369 24.5859C0.828369 18.2207 3.35693 12.1162 7.85781 7.61538C12.3587 3.1145 18.4632 0.585938 24.8284 0.585938C31.1936 0.585938 37.2981 3.1145 41.7989 7.61538C46.2998 12.1162 48.8284 18.2207 48.8284 24.5859ZM21.1984 15.8649C20.9741 15.7052 20.7102 15.6104 20.4355 15.5907C20.1609 15.571 19.8862 15.6273 19.6414 15.7534C19.3966 15.8795 19.1913 16.0706 19.0479 16.3056C18.9045 16.5406 18.8285 16.8106 18.8284 17.0859V32.0859C18.8285 32.3613 18.9045 32.6312 19.0479 32.8663C19.1913 33.1013 19.3966 33.2924 19.6414 33.4185C19.8862 33.5446 20.1609 33.6008 20.4355 33.5812C20.7102 33.5615 20.9741 33.4666 21.1984 33.3069L31.6984 25.8069C31.8928 25.6682 32.0513 25.485 32.1607 25.2726C32.27 25.0602 32.3271 24.8248 32.3271 24.5859C32.3271 24.3471 32.27 24.1116 32.1607 23.8993C32.0513 23.6869 31.8928 23.5037 31.6984 23.3649L21.1984 15.8649Z"
        fill="#2165C5"
      />
    </g>
    <defs>
      <clipPath id="clip0_1002_20060">
        <rect
          width={48}
          height={48}
          fill="white"
          transform="translate(0.828125 0.585938)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const CourseCompleteCheckSVG = (
  props: React.SVGProps<SVGSVGElement>
) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_1315_16574"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="21"
    >
      <rect y="0.5" width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1315_16574)">
      <path
        d="M8.83317 12.0003L7.0415 10.2087C6.88873 10.0559 6.69428 9.97949 6.45817 9.97949C6.22206 9.97949 6.02762 10.0559 5.87484 10.2087C5.72206 10.3614 5.64567 10.5559 5.64567 10.792C5.64567 11.0281 5.72206 11.2225 5.87484 11.3753L8.24984 13.7503C8.4165 13.917 8.61095 14.0003 8.83317 14.0003C9.05539 14.0003 9.24984 13.917 9.4165 13.7503L14.1248 9.04199C14.2776 8.88921 14.354 8.69477 14.354 8.45866C14.354 8.22255 14.2776 8.0281 14.1248 7.87533C13.9721 7.72255 13.7776 7.64616 13.5415 7.64616C13.3054 7.64616 13.1109 7.72255 12.9582 7.87533L8.83317 12.0003ZM9.99984 18.8337C8.84706 18.8337 7.76373 18.6149 6.74984 18.1774C5.73595 17.7399 4.854 17.1462 4.104 16.3962C3.354 15.6462 2.76025 14.7642 2.32275 13.7503C1.88525 12.7364 1.6665 11.6531 1.6665 10.5003C1.6665 9.34755 1.88525 8.26421 2.32275 7.25033C2.76025 6.23644 3.354 5.35449 4.104 4.60449C4.854 3.85449 5.73595 3.26074 6.74984 2.82324C7.76373 2.38574 8.84706 2.16699 9.99984 2.16699C11.1526 2.16699 12.2359 2.38574 13.2498 2.82324C14.2637 3.26074 15.1457 3.85449 15.8957 4.60449C16.6457 5.35449 17.2394 6.23644 17.6769 7.25033C18.1144 8.26421 18.3332 9.34755 18.3332 10.5003C18.3332 11.6531 18.1144 12.7364 17.6769 13.7503C17.2394 14.7642 16.6457 15.6462 15.8957 16.3962C15.1457 17.1462 14.2637 17.7399 13.2498 18.1774C12.2359 18.6149 11.1526 18.8337 9.99984 18.8337Z"
        fill="#1AC868"
      />
    </g>
  </svg>
);

export const ToggleSwitchOffSVG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="42"
    height="26"
    viewBox="0 0 42 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="2" width="40" height="22" rx="11" fill="#D2D5DA" />
    <g filter="url(#filter0_d_1002_26999)">
      <rect x="4" y="2" width="18" height="18" rx="9" fill="white" />
    </g>
    <defs>
      <filter
        id="filter0_d_1002_26999"
        x="0"
        y="0"
        width="26"
        height="26"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.152941 0 0 0 0 0.152941 0 0 0 0 0.152941 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1002_26999"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1002_26999"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const ToggleSwitchOnSVG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="42"
    height="26"
    viewBox="0 0 42 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="40" height="22" rx="11" fill="#2563EB" />
    <g filter="url(#filter0_d_1002_27842)">
      <rect x="20" y="2" width="18" height="18" rx="9" fill="white" />
    </g>
    <defs>
      <filter
        id="filter0_d_1002_27842"
        x="16"
        y="0"
        width="26"
        height="26"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.152941 0 0 0 0 0.152941 0 0 0 0 0.152941 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1002_27842"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1002_27842"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
